<template>
</template>

<script>
  import { login, isLoggedIn } from '../../utils/auth'

  export default {
    name: 'login',
    data () {
      return {}
    },
    mounted () {
      if (isLoggedIn()) {
        this.$router.push(this.$route.query.redirect || '/summary')
      } else {
        if (localStorage.getItem('facilities')) {
          localStorage.removeItem('facilities')
        }
        if (localStorage.getItem('locations')) {
          localStorage.removeItem('locations')
        }
        if (localStorage.getItem('counties')) {
          localStorage.removeItem('counties')
        }
        if (localStorage.getItem('subcounties')) {
          localStorage.removeItem('subcounties')
        }
        if (localStorage.getItem('wards')) {
          localStorage.removeItem('wards')
        }
        localStorage.setItem('preLoginUrl', window.location.href)
        login()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?f3a73f26